module.exports = __webpack_public_path__ + "img/DSM_Bild_Header.7776db90.png";